import { computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import type { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormArray } from '@angular/forms';
import type { Identifiers } from '@hyundai/shared-lib/edit';
import { getValidators } from '@hyundai/shared-lib/edit';
import * as v from 'valibot';

export function ngEditValidator<T, O>(identifier: Identifiers, preprocessValue?: (value: T) => O): ValidatorFn {
    const validators = getValidators(identifier);
    return (control: AbstractControl): ValidationErrors | null => {
        if (!validators) {
            return null;
        }
        const value = preprocessValue ? preprocessValue(control.value) : control.value;
        const result = v.safeParse(validators, value);
        if (result.success) {
            return null;
        }
        return { value: result.issues.map((issue) => issue.message) };
    };
}

export function ngEditValidatorErrors(control: AbstractControl) {
    const changes = toSignal(control.statusChanges);
    return computed(() => {
        if (changes() === 'VALID') return null;
        return control.errors?.['value'];
    });
}

export function ValibotValidator(schema: v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>) {
    return (control: AbstractControl): ValidationErrors | null => {
        const result = v.safeParse(schema, control.value);
        if (result.success) {
            return null;
        }
        return { value: result.issues.map((issue) => issue.message) };
    };
}

export function ngEditMaxCheckboxValidator(maxChecked: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control instanceof FormArray) {
            const checkboxes = control.controls as FormControl[];
            const checkedCount = checkboxes.filter((checkbox) => checkbox.value).length;
            return checkedCount <= maxChecked ? null : { maxCheckedExceeded: true };
        }
        return null;
    };
}
